import React, { useEffect, useState } from 'react'
import { Header } from '@st-operations/uikit/src/v2'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'

import Select from '_components/select'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import { getSourcePartners } from '_services/source-partners'
import toast from '@st-operations/uikit/lib/toast'
import Table from '_components/table/'
import { usePDPEnvironment } from '../../../contexts/PDPEnvContext'
import { ENV_OPTIONS } from '../helpers'

const SourcePartnersPage = () => {
  const { pdpEnvironment, setPDPEnvironment } = usePDPEnvironment()

  const [modalOpen, setModalOpen] = useState(false)
  const [sourcePartners, setSourcePartners] = useState([])

  const fetchSourcePartners = async (env) => {
    try {
      const response = await getSourcePartners(env)
      setSourcePartners(response.items)
    } catch (error) {
      setSourcePartners([])
      toast.error('Error while fetching source partners: ' + error.message)
    }
  }

  useEffect(() => {
    if (pdpEnvironment?.value) {
      fetchSourcePartners(pdpEnvironment.value)
    }
  }, [pdpEnvironment])

  const toggleModal = () => {
    setModalOpen((prev) => !prev)
  }

  return (
    <div>
      <Header
        title={
          <div className="predactiv-admin__header">
            <span>Source Partners</span>
            <Select
              value={pdpEnvironment}
              options={ENV_OPTIONS}
              onChange={(value) => setPDPEnvironment(value)}
            />
          </div>
        }
        actions={[
          {
            children: 'Create New Source Partner',
            onClick: toggleModal,
          },
        ]}
      />
      <If condition={sourcePartners?.length > 0}>
        <div>
          <Table
            columns={[
              {
                name: 'Name',
                key: 'name',
                sortable: true,
                style: { cursor: 'pointer' },
              },
              {
                name: 'Mapping IDs',
                key: 'mappingIds',
                render: (item) =>
                  item.mappingIds && item.mappingIds.map((id) => id.name).join(', '),
              },
              {
                name: 'Partner Id',
                key: '_id',
              },
            ]}
            data={sourcePartners || []}
            sort_dir={1}
            sort_key={'name'}
            onRowClick={(item) => {
              window._history.push(`/source-partners/${item._id}`)
            }}
          />
        </div>
      </If>
      <Dialog open={modalOpen} close={toggleModal}>
        <NewEntityDialog
          close={toggleModal}
          entities="source-partners"
          title="Enter a name for the new Source Partner"
          queryParam={`env=${pdpEnvironment.value}`}
        />
      </Dialog>
    </div>
  )
}

export default SourcePartnersPage
